module.exports = __webpack_public_path__ + "img/BG_Christmas_logo.7160250b.svg";